import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Button, Grid } from '@material-ui/core';
import { FaChevronCircleDown } from 'react-icons/fa';

import { useWindowSize } from '../../../hooks/windowSize';

import { useStyles } from './styles';

interface BottomButton {
  value: string;
  label: string;
}

interface IBottomBar {
  bottomButtonsLabels: BottomButton[];
  bottomBarComponents: any[];
  onCloseBottomBar?: () => void;
  selected: string;
  onSelect: (select: string) => void;
}

const BottomBar: React.FC<IBottomBar> = ({
  bottomButtonsLabels,
  bottomBarComponents,
  onCloseBottomBar,
  selected,
  onSelect,
}) => {
  const classes = useStyles();
  const size = useWindowSize();
  const [componentIndex, setComponentIndex] = useState(-1);

  useEffect(() => {
    const selectedIndex = bottomButtonsLabels.findIndex(
      btn => btn.value === selected,
    );
    setComponentIndex(selectedIndex);
  }, [selected, bottomButtonsLabels]);

  return (
    <Grid
      item
      md={7}
      lg={8}
      xl={9}
      className={classes.bottomBar}
      style={{
        height: size.height ? size.height * 0.33 : '100%',
      }}
    >
      <div className={classes.bottomBarNavButtonsContainer}>
        <button
          type="button"
          onClick={onCloseBottomBar}
          className={classes.floatingButtonBottomBar}
        >
          <FaChevronCircleDown size={24} color="#7030A0" />
        </button>
        <div className={classes.bottomBarNavButtons}>
          {bottomButtonsLabels.map((btn, index) => (
            <Button
              key={`${btn.value}-${index}`}
              variant="contained"
              onClick={() => onSelect(btn.value)}
              className={clsx(classes.selectButton, {
                [classes.active]: selected === btn.value,
              })}
            >
              {btn.label}
            </Button>
          ))}
        </div>
      </div>
      {componentIndex !== -1 && bottomBarComponents[componentIndex]}
    </Grid>
  );
};

export default BottomBar;
